export const AUTH_LOGIN_CODE_URL = "/authorize/login/code/";
export const AUTH_LOGIN_EMAIL_URL = "/authorize/login/email/";
export const AUTH_LOGIN_EMAIL_CODE_URL = "/authorize/login/email/code/";
export const AUTH_LOGIN_BOT_CODE_URL = "/authorize/login/bot/code/";
export const AUTH_LOGIN_BOT_CHECK_URL = "/authorize/bot/check/";
export const AUTH_LOGOUT_URL = "/authorize/logout/";
export const AUTH_DEVICE_URL = "/authorize/device/";
